import React from 'react';
import { string, number } from 'prop-types';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { Heading, Placeholder } from '@thd-olt-component-react/core-ui';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { QAContextProvider } from '../context/QAContext';
import { QAResultDesktop } from './QAResult/QAResultDesktop.component';
import { dataModel } from './dataModel';
import './QuestionsAndAnswers.scss';

const QuestionsAndAnswersDesktopComponent = ({ itemId, seoPageNumber }) => {
  return (
    <div className="grid questions-and-answers">
      <div className="qa-wrapper">
        <Heading title="Questions &amp; Answers" underline className="qa-heading" />
        <QAContextProvider itemId={itemId} seoPageNumber={seoPageNumber}>
          <QueryProvider cacheKey="question-answer-desktop">
            <QAResultDesktop />
          </QueryProvider>
        </QAContextProvider>
      </div>
    </div>
  );
};

QuestionsAndAnswersDesktopComponent.displayName = 'QuestionsAndAnswersDesktop';

QuestionsAndAnswersDesktopComponent.propTypes = {
  itemId: string.isRequired,
  seoPageNumber: number
};

QuestionsAndAnswersDesktopComponent.defaultProps = {
  seoPageNumber: null
};

QuestionsAndAnswersDesktopComponent.dataModel = dataModel;

const HydratedComponent = withHydrator(
  {
    delay: 2000,
    id: 'product-section-qa',
    placeholder: (
      <>
        <Placeholder
          type="rect"
          height="680px"
          showLoadingAnimation
        />
        <Placeholder
          type="text"
          showLoadingAnimation
        />
        <Placeholder
          type="text"
          showLoadingAnimation
        />
        <Placeholder
          type="text"
          showLoadingAnimation
        />
        <Placeholder
          type="text"
          showLoadingAnimation
        />
      </>
    ),
    scrollBuffer: 750,
  },
  QuestionsAndAnswersDesktopComponent
);

const DynamicComponent = withDynamicComponent(HydratedComponent);
export const QuestionsAndAnswersDesktop = withLayoutGroup(
  { name: 'questions_answers_full' },
  DynamicComponent
);

QuestionsAndAnswersDesktop.propTypes = {
  itemId: string.isRequired,
  seoPageNumber: number
};

QuestionsAndAnswersDesktop.defaultProps = {
  seoPageNumber: null
};

QuestionsAndAnswersDesktop.dataModel = dataModel;
